module.exports = __webpack_public_path__ + "img/step1_2.effb9a7c.jpg";